"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useKeyStrokes = exports.default = void 0;
var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));
var _react = require("react");
var KEYSTROKE_TIMEOUT = 500;
var useKeyStrokes = exports.useKeyStrokes = function useKeyStrokes(_ref) {
  var onKeyStrokes = _ref.onKeyStrokes,
    _ref$keyStrokeTimeout = _ref.keyStrokeTimeout,
    keyStrokeTimeout = _ref$keyStrokeTimeout === void 0 ? 500 : _ref$keyStrokeTimeout;
  var _useState = (0, _react.useState)(''),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    keyStrokes = _useState2[0],
    setKeyStrokes = _useState2[1];
  var keyTimer = (0, _react.useRef)(null);
  var timeoutValue = typeof keyStrokeTimeout === 'number' && keyStrokeTimeout >= 0 ? keyStrokeTimeout : KEYSTROKE_TIMEOUT;
  var startTimer = function startTimer() {
    if (typeof setTimeout === 'function') {
      keyTimer.current = setTimeout(function () {
        setKeyStrokes('');
      }, timeoutValue);
    }
  };
  var resetTimer = function resetTimer() {
    if (typeof clearTimeout === 'function') {
      clearTimeout(keyTimer.current);
    }
  };
  (0, _react.useEffect)(function () {
    resetTimer();
    if (keyStrokes !== null && keyStrokes !== void 0 && (0, _trim.default)(keyStrokes).call(keyStrokes)) {
      onKeyStrokes === null || onKeyStrokes === void 0 || onKeyStrokes(keyStrokes);
      startTimer();
    }
    return resetTimer;
  }, [keyStrokes]);
  return {
    keyStrokes: keyStrokes,
    setKeyStrokes: setKeyStrokes
  };
};
var _default = exports.default = useKeyStrokes;